import React, { Component } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingIndicatorComponent from "../utils/loadingIndicator";
import axios from 'axios';

class AppointmentCancellationFinalizationComponent extends Component {

    state = {
        dataRequestSent: false,
        deletePerformed: false
    };

    componentDidMount() {
        this.otkaziRezervaciju(this.props.appointmentId);
    }


    otkaziRezervaciju = (id) => {
        
        var call = "/api/cancel_booking/";
        if(!this.state.dataRequestSent){
            this.state.dataRequestSent = true;
        axios.post(call, { "id": id, "data": this.props.userInformation })
            .then(response => {
                toast.success("Uspešno ste otkazali svoj termin!");
                this.setState({deletePerformed: true})
            })
            .catch(function (error) {
                toast.error("Greška prilikom otkazivanja rezervacije");
            });
        }
      };
  

    render() { 
        if (!this.state.deletePerformed) {
            return <LoadingIndicatorComponent/>
        }

        return (  
            <section className="section-xl bg-periglacial-blue one-screen-page-content text-center">
                <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                />
                <div className="shell">
            <h2>Otkazivanje zakazanog termina</h2>
                <br/><br/>
                <p className="big">Vaš termin je uspešno otkazan! <br/> Kliknite na dugme ispod da biste nastavili sa pregledom svojih termina.</p><br/>
            <button className="btn btn-sm btn-style-1 btn-white-pickled-bluewood" onClick={()=> this.props.onAppointmentCancellationConfirmation()}>Nazad na pregled mojih termina</button>
            </div></section>
      );
    }
}
 
export default AppointmentCancellationFinalizationComponent;